import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { trendingTopics, mockStories, mockRepublishedStories, mockAnalyticsData } from '../data/mockData';
import { ArrowRightIcon, TrendingUpIcon, EyeIcon, BarChart3Icon } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
export function Home() {
  const navigate = useNavigate();
  const recentStories = mockStories.slice(0, 3);
  const recentRepublished = mockRepublishedStories.slice(0, 3);
  return <div className="space-y-8" data-id="element-289">
      {/* Trending Topics */}
      <div className="rounded-xl p-8 shadow-card border border-neutral-200" style={{
      backgroundColor: '#182941'
    }} data-id="element-290">
        <div className="flex items-center gap-3 mb-6" data-id="element-291">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} data-id="element-292">
            <TrendingUpIcon className="w-5 h-5 text-white" data-id="element-293" />
          </div>
          <h2 className="text-2xl font-bold text-display text-white" data-id="element-294">
            Today's Trending Topics
          </h2>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-295">
          {trendingTopics.map((topic, index) => {
          return <button key={topic} onClick={() => navigate(`/explore?search=${encodeURIComponent(topic)}`)} className="px-4 py-2 rounded-lg hover:shadow-md transition-all font-medium text-sm border-2" style={{
            backgroundColor: 'white',
            color: '#0289BB',
            borderColor: '#0289BB'
          }} data-id="element-296">
                {topic}
              </button>;
        })}
        </div>
      </div>
      {/* Analytics Card */}
      <div onClick={() => navigate('/analytics')} className="bg-white rounded-xl p-8 shadow-card border border-neutral-200 cursor-pointer hover:shadow-lg transition-all" data-id="element-297">
        <div className="flex items-center gap-3 mb-6" data-id="element-298">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} data-id="element-299">
            <BarChart3Icon className="w-5 h-5 text-white" data-id="element-300" />
          </div>
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-301">
            Analytics
          </h2>
        </div>
        <ResponsiveContainer width="100%" height={200} data-id="element-302">
          <LineChart data={mockAnalyticsData} data-id="element-303">
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-304" />
            <XAxis dataKey="date" stroke="#6b7280" data-id="element-305" />
            <YAxis stroke="#6b7280" data-id="element-306" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} data-id="element-307" />
            <Line type="monotone" dataKey="views" stroke="#26aedb" strokeWidth={3} dot={{
            fill: '#26aedb',
            r: 4
          }} activeDot={{
            r: 6
          }} data-id="element-308" />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {/* Action Cards with Stories */}
      <div className="grid grid-cols-2 gap-6" data-id="element-309">
        {/* Explore Stories Card */}
        <div className="rounded-xl p-8 shadow-card border-2" style={{
        backgroundColor: 'white',
        borderColor: '#0289BB'
      }} data-id="element-310">
          <div className="flex items-start justify-between mb-6" data-id="element-311">
            <div className="flex items-center gap-3" data-id="element-312">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{
              background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
            }} data-id="element-313">
                <ArrowRightIcon className="w-6 h-6 text-white" data-id="element-314" />
              </div>
              <div data-id="element-315">
                <h2 className="text-2xl font-bold text-display" style={{
                color: '#0289BB'
              }} data-id="element-316">
                  Explore Stories
                </h2>
                <p className="text-neutral-600 text-sm" data-id="element-317">
                  Browse new content from the network
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-3" data-id="element-318">
            {recentStories.map(story => <div key={story.id} onClick={() => navigate('/explore')} className="p-4 rounded-lg hover:bg-blue-50 transition-all cursor-pointer border-2" style={{
            backgroundColor: 'rgba(2, 137, 187, 0.05)',
            borderColor: 'rgba(2, 137, 187, 0.2)'
          }} data-id="element-319">
                <div className="flex items-center justify-between mb-2" data-id="element-320">
                  <span className="text-sm font-medium" style={{
                color: '#0289BB'
              }} data-id="element-321">
                    {story.brand}
                  </span>
                  <div className="flex items-center gap-2" data-id="element-322">
                    <span className="inline-block px-2 py-1 rounded text-xs font-semibold text-white" style={{
                  background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
                }} data-id="element-323">
                      {story.category}
                    </span>
                    <span className="text-xs text-neutral-600" data-id="element-324">
                      {new Date(story.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                    </span>
                  </div>
                </div>
                <h3 className="font-semibold mb-1 line-clamp-1" style={{
              color: '#0289BB'
            }} data-id="element-325">
                  {story.title}
                </h3>
                <p className="text-sm text-neutral-600 line-clamp-2" data-id="element-326">
                  {story.excerpt}
                </p>
              </div>)}
          </div>
          <button onClick={() => navigate('/explore')} className="w-full mt-6 py-3 rounded-lg transition-all font-medium flex items-center justify-center gap-2 border-2 text-white" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)',
          borderColor: '#0289BB'
        }} data-id="element-327">
            View All Stories
            <ArrowRightIcon className="w-4 h-4" data-id="element-328" />
          </button>
        </div>
        {/* Republished Stories Card */}
        <div className="rounded-xl p-8 shadow-card border-2" style={{
        backgroundColor: 'white',
        borderColor: '#016595'
      }} data-id="element-329">
          <div className="flex items-start justify-between mb-6" data-id="element-330">
            <div className="flex items-center gap-3" data-id="element-331">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{
              background: 'linear-gradient(135deg, #0277a8 0%, #016595 50%, #015382 100%)'
            }} data-id="element-332">
                <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-333" />
              </div>
              <div data-id="element-334">
                <h2 className="text-2xl font-bold text-display" style={{
                color: '#016595'
              }} data-id="element-335">
                  Republished Stories
                </h2>
                <p className="text-neutral-600 text-sm" data-id="element-336">
                  View your published content
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-3" data-id="element-337">
            {recentRepublished.map(story => <div key={story.id} onClick={() => navigate('/republished')} className="p-4 rounded-lg hover:bg-blue-50 transition-all cursor-pointer border-2" style={{
            backgroundColor: 'rgba(1, 101, 149, 0.05)',
            borderColor: 'rgba(1, 101, 149, 0.2)'
          }} data-id="element-338">
                <h3 className="font-semibold mb-2 line-clamp-1" style={{
              color: '#016595'
            }} data-id="element-339">
                  {story.storyTitle}
                </h3>
                <div className="flex items-center gap-3 text-sm text-neutral-600" data-id="element-340">
                  <span data-id="element-341">{story.republishedAt}</span>
                  <span data-id="element-342">•</span>
                  <span data-id="element-343">{story.user}</span>
                  <span data-id="element-344">•</span>
                  <div className="flex items-center gap-1" data-id="element-345">
                    <EyeIcon className="w-4 h-4" data-id="element-346" />
                    <span className="font-semibold" style={{
                  color: '#016595'
                }} data-id="element-347">
                      {story.pageViews.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
          <button onClick={() => navigate('/republished')} className="w-full mt-6 py-3 rounded-lg transition-all font-medium flex items-center justify-center gap-2 border-2 text-white" style={{
          background: 'linear-gradient(135deg, #0277a8 0%, #016595 50%, #015382 100%)',
          borderColor: '#016595'
        }} data-id="element-348">
            View All Stories
            <ArrowRightIcon className="w-4 h-4" data-id="element-349" />
          </button>
        </div>
      </div>
    </div>;
}